import { captureRequestScope } from '@/lib/api/request-scope'
import { desktopSecureStorage, isTauri } from '@/lib/utils/tauri'

export function captureInteractiveOwner() {
  const session = captureRequestScope()
  return {
    assertCurrentSync: () => session.assertCurrent(),
    async assertCurrent() {
      if (isTauri()) await desktopSecureStorage.assertSessionCurrent(session)
      session.assertCurrent()
    },
    isCurrent() {
      try {
        session.assertCurrent()
        return true
      } catch {
        return false
      }
    },
  }
}
